import { useQuery } from '@tanstack/react-query';
import { plansApi } from '../api/plans.api';
import type { PlanDetail } from '../types/plans.types';
import { planKeys } from './queryKeys';

export const usePlans = () => {
  const { data, isLoading, isError } = useQuery({
    queryKey: planKeys.list(),
    queryFn: () => plansApi.getPlans(),
  });

  return {
    plans: data?.data ?? [],
    isLoading,
    isError,
  };
};

export const usePlanById = (planId: string) => {
  const { data, isLoading, isError } = useQuery({
    queryKey: planKeys.detail(planId),
    queryFn: () => plansApi.getPlanById(planId),
    enabled: !!planId,
    retry: false,
  });

  return {
    plan: data?.data as PlanDetail | undefined,
    isLoading,
    isError,
  };
};
